const GeneralInfoHeader = () => {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-teal-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 relative z-10">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-teal-500/20 rounded-2xl mb-6 animate-float">
            <i className="ri-information-line text-4xl text-teal-400"></i>
          </div>
          
          <h1 className="font-display text-6xl font-bold text-white mb-6 animate-fade-in">
            Genel Bilgiler
          </h1>
          
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed animate-slide-up">
            Genç Diş Hekimliği Derneği 2. Ulusal İstanbul Kongresi hakkında bilmeniz gereken tüm detaylar.
            Kongre mekanı, tarihler, sertifika ve diğer bilgiler için aşağıdaki bölümleri inceleyebilirsiniz.
          </p>

          <div className="mt-12 flex items-center justify-center gap-8 flex-wrap">
            <div className="flex items-center gap-3 animate-slide-up" style={{ animationDelay: '0.1s' }}>
              <div className="w-12 h-12 bg-teal-500/20 rounded-full flex items-center justify-center">
                <i className="ri-map-pin-line text-xl text-teal-400"></i>
              </div>
              <div className="text-left">
                <div className="text-sm text-gray-400">Konum</div>
                <div className="text-white font-semibold">İstanbul Atlas Üniversitesi Kongre Merkezi</div>
              </div>
            </div>

            <div className="flex items-center gap-3 animate-slide-up" style={{ animationDelay: '0.2s' }}>
              <div className="w-12 h-12 bg-teal-500/20 rounded-full flex items-center justify-center">
                <i className="ri-calendar-2-line text-xl text-teal-400"></i>
              </div>
              <div className="text-left">
                <div className="text-sm text-gray-400">Tarih</div>
                <div className="text-white font-semibold">02 – 03 Mayıs 2026</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GeneralInfoHeader;
